module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/ZehZhW718m6sIDhKDylBv-94e7fedfe277df84e17209049933e53c.jpg";